import { COLOR } from 'admin/constants/styles';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export default styled(Link)`
  color: ${COLOR.primaryColor};
`;
